// extracted by mini-css-extract-plugin
module.exports = {"link":"GlobalHeaderNavMenuItem_link__Izm25","linkCaret":"GlobalHeaderNavMenuItem_linkCaret__Dc2VL","newNavMenuItem":"GlobalHeaderNavMenuItem_newNavMenuItem__oigCO"};